"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = void 0;
var React = _interopRequireWildcard(require("react"));
var _Alert = require("../alert/Alert");
var _utility = require("../utility");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
;
var Checkbox = /*#__PURE__*/function (_React$Component) {
  _inherits(Checkbox, _React$Component);
  var _super = _createSuper(Checkbox);
  function Checkbox(props) {
    var _this;
    _classCallCheck(this, Checkbox);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "checkboxRef", void 0);
    _defineProperty(_assertThisInitialized(_this), "renderErrorMessage", function (message) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, message && /*#__PURE__*/React.createElement("div", {
        className: "tl-input-footer"
      }, /*#__PURE__*/React.createElement(_Alert.Alert, {
        name: "alert-inline-warning",
        icon: "icon-system-alert-small",
        label: message,
        labelClass: "error-message body14-light",
        ariaLabel: "error",
        id: "checkbox-error-content-" + _this.props.id
      })));
    });
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.checkboxRef = /*#__PURE__*/React.createRef();
    return _this;
  }
  _createClass(Checkbox, [{
    key: "handleChange",
    value: function handleChange(event) {
      if (this.props.onChange) {
        this.props.onChange(event);
      }
      ;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        id = _this$props.id,
        name = _this$props.name,
        required = _this$props.required,
        className = _this$props.className,
        label = _this$props.label,
        disabled = _this$props.disabled,
        indeterminate = _this$props.indeterminate,
        alternateIndeterminate = _this$props.alternateIndeterminate,
        checked = _this$props.checked,
        onClick = _this$props.onClick,
        value = _this$props.value,
        defaultChecked = _this$props.defaultChecked,
        _this$props$errorMess = _this$props.errorMessage,
        errorMessage = _this$props$errorMess === void 0 ? '' : _this$props$errorMess,
        ariaErrObj = _this$props.ariaErrObj;
      if (this.checkboxRef.current && indeterminate === true) {
        this.checkboxRef.current.checked = false;
        this.checkboxRef.current.indeterminate = true;
      }
      var classname = (0, _utility.classNames)("tl-ui tl-checkbox", alternateIndeterminate ? "tl-checkbox-component-able-alt" : "tl-checkbox-component-able", className);
      var labelClassName = (0, _utility.classNames)("".concat(!label ? 'unlabeled' : ''));
      return /*#__PURE__*/React.createElement("div", {
        className: "tl-checkbox-component-able-wrapper"
      }, /*#__PURE__*/React.createElement("div", {
        className: classname
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: id,
        name: name,
        value: value,
        disabled: disabled,
        checked: checked,
        onClick: onClick,
        onChange: this.handleChange,
        required: required,
        defaultChecked: defaultChecked,
        ref: this.checkboxRef,
        "aria-invalid": ariaErrObj && ariaErrObj['aria-invalid'],
        "aria-describedby": ariaErrObj && ariaErrObj['aria-describedby']
      }), /*#__PURE__*/React.createElement("label", {
        className: (0, _utility.classNames)('text-regular', disabled && 'tl-label-disabled', labelClassName),
        htmlFor: id,
        onClick: function onClick(e) {
          e.stopPropagation();
        }
      }, label)), this.renderErrorMessage(errorMessage));
    }
  }]);
  return Checkbox;
}(React.Component);
exports.Checkbox = Checkbox;
;